export enum DashboardResultsColumnEnum {
    ORDER_NAME,
    NUMBER_OF_REACTIONS,
    RESULTED,
    DOWNLOAD,
}

export const dashboardResultsTableColumnText: Record<DashboardResultsColumnEnum, string> = {
    [DashboardResultsColumnEnum.ORDER_NAME]: 'dashboard.orderResults.table.column.orderName',
    [DashboardResultsColumnEnum.NUMBER_OF_REACTIONS]: 'dashboard.orderResults.table.column.numberOfReactions',
    [DashboardResultsColumnEnum.RESULTED]: 'dashboard.orderResults.table.column.resulted',
    [DashboardResultsColumnEnum.DOWNLOAD]: 'dashboard.orderResults.table.column.download',
};
